export const instrumentationViews = {
    TeamSettings: "TeamSettings",
    CopyShiftActivitiesSettingFREDialog: "CopyShiftActivitiesSettingFREDialog"
};
